module.exports = __webpack_public_path__ + "static/media/sudoGPRnine.5265540e.jpg";